"use client";

import { Button } from "@papier/ui/components/ui/button";
import { Input } from "@papier/ui/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@papier/ui/components/ui/select";
import { Trash2 } from "lucide-react";
import { SchemaField } from "@papier/grapesjs-editor/src/components/editor/schema-builder/types/schema";

interface PrimitiveExampleEditorProps {
  example: any;
  field: SchemaField;
  onUpdate: (value: any) => void;
  onRemove: () => void;
}

export function PrimitiveExampleEditor({
  example,
  field,
  onUpdate,
  onRemove,
}: PrimitiveExampleEditorProps) {
  return (
    <div className="flex gap-2">
      {field.type === "enum" ? (
        <Select value={example} onValueChange={onUpdate}>
          <SelectTrigger className="flex-1">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {field.enumValues?.map((value) => (
              <SelectItem key={value} value={value}>
                {value}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      ) : field.type === "boolean" ? (
        <Select value={example.toString()} onValueChange={(value) => onUpdate(value === "true")}>
          <SelectTrigger className="flex-1">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="true">true</SelectItem>
            <SelectItem value="false">false</SelectItem>
          </SelectContent>
        </Select>
      ) : (
        <Input
          className="flex-1"
          value={example}
          onChange={(e) => {
            const value = field.type === "number" ? Number(e.target.value) || 0 : e.target.value;
            onUpdate(value);
          }}
          type={field.type === "number" ? "number" : field.type === "date" ? "date" : "text"}
        />
      )}
      <Button variant="outline" size="sm" onClick={onRemove}>
        <Trash2 className="h-4 w-4" />
      </Button>
    </div>
  );
}
